import { createSelector } from 'reselect';
import { subselect } from './root';

const ANON_AVATAR_IMG = '/assets/images/anonUserAvatar.png';

const userAvatarSelector = createSelector(
  [(chat) => chat.avatarUrl, (state, props, globalState) => globalState.userAccount.socialAvatar],
  (chatAvatar, socialAvatar) => chatAvatar || socialAvatar || ANON_AVATAR_IMG,
);

export const chatUserAvatarSelector = subselect(userAvatarSelector);
